<script>
  import {faTrashAlt, faBackward, faSave} from '@fortawesome/free-solid-svg-icons'
  import ReallyClick from '../generic/ReallyClick.vue'

  export default {
    components: {
      ReallyClick
    },
    data () {
      return {
        iconSave: faSave,
        iconDelete: faTrashAlt,
        iconBack: faBackward
      }
    },
    methods: {
      deleteClicked () {
        this.$emit('delete')
      }
    },
    props: {
      store: { type: String, required: true},
      showDelete: {type: Boolean, default: true},
      canDelete: {type: Boolean, default: true}
    }
  }
</script>
<template>
  <b-row class="edit-header">
    <b-col cols="12">
      <b-button @click="$router.go(-1)"><font-awesome-icon :icon="iconBack"></font-awesome-icon> {{$t('button.back')}}</b-button>

      <really-click
        v-if="showDelete"
        :disabled="!canDelete"
        :title="$t('button.delete')"
        :message="store + '.messages.delete-confirm'"
        @click="deleteClicked()"
        variant="danger"
        class="float-right"
      >
        <font-awesome-icon :icon="iconDelete" /> Delete
      </really-click>
      <b-button type="submit" class="btn btn-success float-right"><font-awesome-icon :icon="iconSave"></font-awesome-icon> Submit</b-button>
      <slot></slot>
    </b-col>
  </b-row>
</template>
